// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FSZAhAlBNcoU5W {
  box-sizing: border-box;
  width: 32px;
  height: 24px;
  margin-top: var(--ds-space-050, 4px);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  padding: 3px 7px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-300, 12px);
  line-height: 1;
  cursor: pointer;
}
.FSZAhAlBNcoU5W:hover {
  border: 1px solid var(--ds-border, #091e4224);
}
.FSZAhAlBNcoU5W .F835C5MmjkWwIj {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  background-size: contain;
}
.FSZAhAlBNcoU5W .F835C5MmjkWwIj ._7jsuC2WQ758Qkc {
  width: 100%;
  height: 100%;
}
.FSZAhAlBNcoU5W .F835C5MmjkWwIj ._7jsuC2WQ758Qkc path {
  fill: var(--ds-icon-subtle, #626f86);
}
.FSZAhAlBNcoU5W.fs9FgQ7hshMAY8 {
  border-color: var(--ds-border-brand, #0c66e4);
  background-color: var(--ds-background-brand-bold, #0c66e4);
}
.FSZAhAlBNcoU5W.fs9FgQ7hshMAY8 .F835C5MmjkWwIj path {
  fill: var(--ds-icon-inverse, #ffffff);
}
.FSZAhAlBNcoU5W.Nw_eJn7kdLqX1N {
  cursor: default;
  pointer-events: none;
}
.FSZAhAlBNcoU5W.Nw_eJn7kdLqX1N .F835C5MmjkWwIj path {
  fill: var(--ds-icon-disabled, #091e424f);
}
.FSZAhAlBNcoU5W.EiAwTiH9GR235d {
  display: inline-block;
  width: 13px;
  height: 13px;
  margin: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  border: 0;
  border-radius: 0;
  background-color: transparent;
  vertical-align: text-bottom;
}
.FSZAhAlBNcoU5W.EiAwTiH9GR235d:hover {
  background-color: transparent;
}
.FSZAhAlBNcoU5W.EiAwTiH9GR235d .F835C5MmjkWwIj {
  width: 12px;
  height: 12px;
}
.FSZAhAlBNcoU5W.EiAwTiH9GR235d:hover .F835C5MmjkWwIj path {
  fill: var(--ds-icon-accent-gray, #758195);
}
.FSZAhAlBNcoU5W.EiAwTiH9GR235d.fs9FgQ7hshMAY8 .F835C5MmjkWwIj path {
  fill: var(--ds-icon-brand, #0c66e4);
}
.FSZAhAlBNcoU5W.EiAwTiH9GR235d.Nw_eJn7kdLqX1N .F835C5MmjkWwIj {
  pointer-events: none;
}
.FSZAhAlBNcoU5W.EiAwTiH9GR235d.P4D0fOuOf3S0RE {
  display: flex;
  align-items: center;
  width: 24px;
  margin-top: var(--ds-space-0, 0);
  margin-right: var(--ds-space-0, 0);
}
.FSZAhAlBNcoU5W.EiAwTiH9GR235d.P4D0fOuOf3S0RE::after {
  content: '•';
  margin-left: var(--ds-space-075, 6px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.FSZAhAlBNcoU5W.cZkqKDYATapvmt {
  width: 32px;
  height: 24px;
  margin-bottom: var(--ds-space-050, 4px);
  padding: var(--ds-space-075, 5px) var(--ds-space-100, 9px);
}
.FSZAhAlBNcoU5W.cZkqKDYATapvmt .F835C5MmjkWwIj {
  width: 12px;
  height: 12px;
}
`, ""]);
// Exports
export var reactionAddButton = `FSZAhAlBNcoU5W`;
export var icon = `F835C5MmjkWwIj`;
export var iconSvg = `_7jsuC2WQ758Qkc`;
export var active = `fs9FgQ7hshMAY8`;
export var disabled = `Nw_eJn7kdLqX1N`;
export var small = `EiAwTiH9GR235d`;
export var smallCardBack = `P4D0fOuOf3S0RE`;
export var cardBack = `cZkqKDYATapvmt`;
export default ___CSS_LOADER_EXPORT___;
